import Vue from 'vue'
import '@/assets/main.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import { LayoutPlugin, ButtonPlugin, CardPlugin } from 'bootstrap-vue'
import titleMixin from './mixins/titleMixin'
import VueGtag from 'vue-gtag'
import VueI18n from 'vue-i18n'
import messages from './i18n.json'

Vue.use(VueI18n)
Vue.use(LayoutPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(VueGtag, {
  config: { id: 'UA-78241044-2', params: { anonymize_ip: true } },
  bootstrap: false
})

const availableLocales = ['pt', 'es']
// let locale = navigator.language.split('-')[0]
// if (!availableLocales.includes(locale)) locale = availableLocales[0]
let locale = availableLocales[0]

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: availableLocales[0],
  messages
})

Vue.config.productionTip = false
Vue.mixin(titleMixin)


Vue.filter('currency', function (value) {
  return `${value} €`;
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')